import { render, staticRenderFns } from "./EnrollOrder.vue?vue&type=template&id=327237c2&"
import script from "./EnrollOrder.vue?vue&type=script&lang=js&"
export * from "./EnrollOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports